<template>
  <el-dialog class="schedule_detail m-t-60"  title="Ачааны дэлгэрэнгүй" :visible.sync="this.$root.deliveryDetailDialog" :before-close="handleClose" width="350px" center>
    <el-row type="flex" class="row-bg m-b-100" justify="center">
      <el-col :span="24" class="home_body">
        <el-card shadow="always" :body-style="{ padding: '10px' }" style="border-radius:0px;line-height:2">
          <el-row>
            <el-col :span="24" :offset="1">
              <el-row>
                <el-col :span="24">
                  <span v-if=this.deliveryDetails.phone class="standart_text">Утасны дугаар: </span><a class="blue_color_text" :href="'tel:'
                  + this.deliveryDetails.phone ">{{ this.deliveryDetails.phone }}</a>
                </el-col>
                <el-col :span="24" v-if="this.deliveryDetails.hvrgvvleh_ognoo">
                  <span class="standart_text">Хүргүүлэх огноо:</span> {{this.deliveryDetails.hvrgvvleh_ognoo.split('T')[0]}}
                </el-col>
                <el-col :span="24">
                  <span v-if=this.deliveryDetails.Address class="standart_text no_wrap"> Хаяг: {{ this.deliveryDetails.Address.detail_address }}</span>
                  <span class="standart_text"> Хаягийн линк: </span>
                  <span v-if="deliveryDetails.Address && deliveryDetails.Address.lat && deliveryDetails.Address.lng">
                    <a :href="`https://www.google.com/maps?q=${deliveryDetails.Address.lat},${deliveryDetails.Address.lng}`"
                      target="_blank" rel="noopener noreferrer" style="color: #409EFF; text-decoration: underline;">Газрын зураг харах</a>
                  </span>
                </el-col>
                <el-col :span="24">
                  <span v-if="this.deliveryDetails.Address">
                    <p class="standart_text">Ажилтны тэмдэглэл:</p>
                    <p class="no_wrap"> {{ this.deliveryDetails.Address.description }}</p>
                  </span>
                </el-col>
                <el-col v-if="this.deliveryDetails.DeliveryDetail && this.deliveryDetails.DeliveryDetail.length">
                  Ачааны тоо: {{ this.deliveryDetails.DeliveryDetail.length }}
                </el-col>
                <el-col>
                  <span class="standart_text">Захиалсан бүтээгдэхүүн</span>
                </el-col>
                <el-col>
                  {{this.deliveryDetails.DeliveryDetail.TrackCode}}
                </el-col>
                <div v-if="this.deliveryDetails.DeliveryDetail && this.deliveryDetails.DeliveryDetail.length">
                  <div>
                    <el-col :span="24" v-for="(item, index) in this.deliveryDetails.DeliveryDetail" :key="index">
                      <el-tag class="m-t-10">
                        {{ index + 1 }}.
                        {{ item.TrackCode.track_code }}
                      </el-tag><br>
                      <span v-if="item.TrackCode && item.TrackCode.jin" class="m-l-3 text_size_8 text_color_grey">Жин - {{ item.TrackCode.jin }}гр</span>
                      <span v-if="item.TrackCode && item.TrackCode.urt" class="m-l-3 text_size_8 text_color_grey">/ Урт - {{ item.TrackCode.urt }}см</span>
                      <span v-if="item.TrackCode && item.TrackCode.undur" class="m-l-3 text_size_8 text_color_grey">/ Өндөр - {{ item.TrackCode.undur }}см</span>
                      <span v-if="item.TrackCode && item.TrackCode.urgun" class="m-l-3 text_size_8 text_color_grey">/ Өргөн - {{ item.TrackCode.urgun }}см</span>
                    </el-col>
                  </div>
                </div>
                <div v-if="this.deliveryDetails.status !== 200">
                  <el-col class="m-t-20">
                    <span class="standart_text"> Google map солих: </span>
                  </el-col>
                  <el-col :span="22">
                    <el-input class="m-t-10 w-100" type="textarea"
                      placeholder="Та google map-аас copy хийж дараагийн хүн олоход туслаарай :)" v-model="map_link">
                    </el-input>
                  </el-col>
                  <el-col :span="22">
                    <el-button :disabled="mapDisable()" class="w-100" type="success" size="mini" @click="updateDelivery(null)">Map хадгалах</el-button>
                  </el-col>
                  <el-col class="m-t-20">
                    <span class="standart_text"> Хаягийн нэмэлт тайлбар солих: </span>
                  </el-col>
                  <el-col :span="22">
                    <el-input class="m-t-10" type="textarea"
                      placeholder="Та энэ захиалга дээр тэмдэглэл өөрчлөх бол бичээрэй" v-model="description">
                    </el-input>
                  </el-col>
                  <el-col :span="22">
                    <el-button :disabled="descriptionDisable()" class="w-100" type="success" size="mini" @click="updateDelivery(null)">Тэмдэглэл хадгалах</el-button>
                  </el-col>
                </div>
              </el-row>
            </el-col>
            <div v-if="this.deliveryDetails.status !== 200">
              <el-col :span="24" class="m-t-20">
                <el-button type="warning" size="mini" class="w-100 m-t-10" @click="changeDriverDialogOpen()">Жолоочид шилжүүлэх</el-button>
              </el-col>
              <el-col :span="24" class="m-b-20">
                <el-button type="success" size="mini" class="w-100 m-t-10" @click="updateDelivery(200)">Амжилттай хүргэсэн</el-button>
              </el-col>
            </div>
          </el-row>
          <el-dialog  title="Ачааны дэлгэрэнгүй" :visible.sync="this.driverChangeDialog" :before-close="handleCloseDriverChangeDialog" width="350px" center class="m-t-20">
            <div class="p-20">
              <el-row>
                <el-col>
                  <el-radio-group v-model="driver_id">
                    <el-row>
                      <el-col :span="24">
                        <el-radio v-for="item, index in workersList" :key="index" :label="item.id" class="m-t-10 w-100">{{ item.lastName }}</el-radio>
                      </el-col>
                    </el-row>
                  </el-radio-group>
                </el-col>
                <el-col :span="24" class="m-t-20">
                  <el-button class="w-100" @click="handleCloseDriverChangeDialog()" size="mini">Буцах</el-button>
                </el-col>
                <el-col :span="24" class="m-t-10">
                  <el-button class="w-100" type="success" size="mini" :disabled="driverSaveDisable()" @click="updateDelivery(200)">Шилжүүлэх</el-button>
                </el-col>
              </el-row>
            </div>
          </el-dialog>
        </el-card>
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
import services from '@/helpers/services.js'
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      selectedOrder: 'getterSelectOrderDetail',
      userGetter: 'userGetter'
    })
  },
  data () {
    return {
      driverChangeDialog: false,
      map_link: null,
      description: null,
      workersList: [],
      driver_id: null
    }
  },
  props: {
    deliveryId: {
      type: Number,
      default: null
    },
    deliveryDetails: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    updateDelivery (data) {
      this.$root.fullscreenLoading = true

      let lat = null
      let lng = null

      if (this.map_link) {
        const regex = /@(-?\d+\.\d+),(-?\d+\.\d+)/
        const match = this.map_link.match(regex)
        if (match) {
          lat = parseFloat(match[1])
          lng = parseFloat(match[2])
        } else {
          this.$message.error('Google Map линк буруу байна.')
          this.$root.fullscreenLoading = false
          return
        }
      }

      const payload = {
        id: this.deliveryDetails.id,
        lat: lat,
        lng: lng,
        description: this.description,
        driver_id: this.driver_id,
        address_id: this.deliveryDetails.Address.id,
        deliveries: this.deliveryDetails.DeliveryDetail,
        progress_code: data
      }

      services.updateDelivery(payload)
        .then(response => {
          if (response.type === 'success') {
            this.$notify({
              title: 'Амжилттай',
              message: 'Хадгалагдлаа!',
              type: 'success'
            })
            this.description = null
            this.map_link = null
            this.driver_id = null
            this.$root.deliveryDetailDialog = false
            this.$root.driverChangeDialog = false
            this.$emit('reloadDelivery')
          }
          this.$root.fullscreenLoading = false
        })
        .catch(err => {
          console.log(err)
          this.$message.error('Алдаа гарлаа!')
          this.$root.fullscreenLoading = false
        })
    },
    handleClose () {
      this.$root.deliveryDetailDialog = false
    },
    handleCloseDriverChangeDialog () {
      this.driverChangeDialog = false
    },
    changeDriverDialogOpen () {
      this.driverChangeDialog = true
      this.getAllWorkers()
    },
    descriptionDisable () {
      if (this.description) {
        return false
      } else {
        return true
      }
    },
    mapDisable () {
      if (this.map_link) {
        return false
      } else {
        return true
      }
    },
    getAllWorkers () {
      this.$root.fullscreenLoading = true
      services.getAllWorkers()
        .then(response => {
          if (response.type === 'success') {
            this.workersList = response.data
          }
          this.$root.fullscreenLoading = false
        }).catch((err) => {
          console.log(err)
          this.$root.fullscreenLoading = false
        })
    },
    driverSaveDisable () {
      if (this.driver_id) {
        return false
      } else {
        return true
      }
    }
  }
}

</script>

<style>

</style>
